import { LearningTestimonialType } from '../../graphql/api-platform-graphql';

/**
 * Currently, no testimonials which are coming from
 * the CMS are 1:1 mapped to the event types. This function is used to get the event type for the testimonial.
 *
 * @param testimonialType
 */
export const getTestimonialEventTypeFromSchemaType = testimonialType => {
  const types = {
    [LearningTestimonialType.CaseStudy]: 'case-study',
    [LearningTestimonialType.CourseReview]: 'course-review',
    [LearningTestimonialType.ThirdParty]: 'third-party'
  };
  return types[testimonialType];
};
//# sourceMappingURL=get-testimonial-event-types.js.map